module.exports = __webpack_public_path__ + "img/sao-jose.9fa1d3ed.svg";